<script>
import StringUtils from '@/utils/stringUtils'

export default
{
    name: 'collapsible',

    props:
    {
        icon: {type: String, default: null},
        inlineSvg: {type: Boolean, default: false},
        title: { type: String, required: true },
        description: { type: String },
        descriptionNode: { type: Object },
        actions: { },
        expanded: { type: Boolean },
        descriptionOverflow: { type: Object, default: () => ({chars: 120, lines: 3}) }
    },

    render () 
    {
        var desc = StringUtils.trim(this.description, this.descriptionOverflow)
        var content = ''
        if (this.isDescriptionOverflowing)
        {
            if (this.isExpanded) desc = ''
            content = this.description
        }

        return (
            <div class={`collapsible ${this.isExpanded ? 'is-expanded' : ''}`} style={{ whiteSpace: this.isExpanded ? 'pre-line' : 'inherit' }}
                on-click={this.onCardClicked}>
                <div class='content'>
                    <div class='header'>
                    {
                        this.icon && this.inlineSvg ?
                        (
                            <inline-svg skip-embedded-size={true} class='icon' src={this.icon} />
                        ) :
                        (
                            typeof this.icon == 'string'
                                ? <img class='icon' src={this.icon} />
                                : <div class='icon vnode' v-show={this.icon}>{this.icon}</div>
                        )
                    }
                        <div class='content' on-click={this.onHeaderClicked}>
                            <p class='title'>{ this.title }</p>
                            <p class='description' domPropsInnerHTML={desc}></p>
                            {this.descriptionNode && <div class='description'>{this.descriptionNode}</div>}
                        </div>
                        <div v-show={this.actions} class='actions'> 
                            { this.actions }
                        </div>
                    </div>
                    <div class='expandable' v-show={this.isExpanded}>
                        <div domPropsInnerHTML={content} />
                        { this.$slots.default }
                    </div>
                </div>
                <div v-show={this.showExpandButton} class='expand' on-click={this.onExpandClicked}>
                    <inline-svg class='icon' src={require('@/assets/img/back.svg')} ref='expandIcon' />
                </div>
            </div>
        )
    },

    data () 
    {
        return {
            isExpanded: this.expanded
        }
    },

    watch:
    {
        expanded ()
        {
            this.isExpanded = this.expanded
        },

        isExpanded ()
        {
            const expandIcon = this.$refs.expandIcon.$el
            const expandIconRotation = this.isExpanded ? 90 : -90

            if (!expandIcon || !expandIcon.style) return 
            expandIcon.style.transform = `rotate(${expandIconRotation}deg)`
        }
    },

    computed:
    {
        isDescriptionOverflowing ()
        {
            return StringUtils.isOverflowing(this.description, this.descriptionOverflow)
        },

        showExpandButton ()
        {
            return !!this.$slots.default || this.isDescriptionOverflowing
        }
    },

    mounted ()
    {
        this.isExpanded = this.expanded
    },

    methods:
    {
        onCardClicked (event)
        {
            this.$emit('click', event, this)
        },

        onHeaderClicked ()
        {
            this.isExpanded = !this.isExpanded
        },
        onExpandClicked ()
        {
            this.isExpanded = !this.isExpanded
        }
    },

    components:
    {
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

.collapsible
{
    display: flex;
    flex-direction: column;
    border-radius: 8px;
    background-color: var(--theme-content-background-color);
    font-size: 3.3vw;
    box-shadow: var(--theme-box-shadow-soft);

    .OnTablet({ font-size: 2vw; });
    .OnDesktop({ font-size: 1.5vh; });

    &.is-expanded
    {
        .content
        {
            padding-bottom: 0;
        }
    }

    > .content
    {
        padding: 15px 20px;

        .OnTablet({ padding: 30px; });
        .OnDesktop({ padding: 3.5%; });

        > .header
        {
            display: flex;
            justify-content: space-between;
            width: -webkit-fill-available;
            cursor: pointer;

            > .icon
            {
                margin-right: 20px;
                width: 40px;
                height: 40px;
                border-radius: 6px;
                fill: var(--theme-background-text-color);
                align-self: center;

                &.vnode
                {
                    > *
                    {
                        width: inherit;
                        height: inherit;
                    }
                }
            }

            > .content
            {
                width: inherit;
                align-self: center;

                .title
                {
                    font-size: 4.5vw;
                    font-weight: 500;
                    .CapitalizeFirstLetter();

                    .OnTablet({ font-size: 2.6vw; });
                    .OnDesktop({ font-size: 2vh; });
                }

                .description
                {
                    .CapitalizeFirstLetter();
                    margin-top: 3%;
                    white-space: pre-wrap;
                }
            }

            > .actions
            {
                text-align: right;
            }
        }

        > .expandable
        {
            padding: 15px 0px;
            .CapitalizeFirstLetter();

            img
            {
                width: 100%;
            }
        }
    }

    > .expand
    {
        display: flex;
        justify-content: center;
        width: -webkit-fill-available;
        padding-top: 8px;
        padding-bottom: 8px;
        border-top: 1px solid var(--theme-border-color-light);
        background-color: var(--theme-border-color-hyper-light);
        transition: background-color 0.1s ease-in-out;
        cursor: pointer;
        border-radius: inherit;
        border-top-left-radius: 0;
        border-top-right-radius: 0;

        &:hover
        {
            background-color: var(--theme-border-color-mega-light);
        }

        .icon
        {
            width: 4vw;
            height: 4vw;
            transform: rotate(-90deg);
            transition: transform .20s ease-out;
            fill: var(--theme-text-color-extra-light);

            .OnTablet({ .WidthHeight(2.5vw); });
            .OnDesktop({ .WidthHeight(1vw); });
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Collapsible.vue